var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96245 0.654421C5.13165 0.13368 5.86835 0.133679 6.03755 0.65442L6.83244 3.10083C6.90811 3.33372 7.12513 3.49139 7.37 3.49139H9.94231C10.4898 3.49139 10.7175 4.19204 10.2745 4.51388L8.19349 6.02584C7.99539 6.16977 7.91249 6.42489 7.98816 6.65778L8.78305 9.10419C8.95225 9.62493 8.35624 10.058 7.91327 9.73612L5.83223 8.22416C5.63413 8.08023 5.36588 8.08023 5.16777 8.22416L3.08673 9.73612C2.64376 10.058 2.04775 9.62493 2.21695 9.10419L3.01184 6.65778C3.08751 6.42489 3.00461 6.16977 2.80651 6.02584L0.725467 4.51388C0.282498 4.19204 0.510153 3.49139 1.05769 3.49139H3.63C3.87487 3.49139 4.09189 3.33372 4.16756 3.10083L4.96245 0.654421Z",
    fill: "#FFE24B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dc84343cb7ef823d63ca60f3b58fa5a3.svg";
export { ForwardRef as ReactComponent };